<template>
  <el-dialog
    :visible.sync="showModal"
    :center="true"
    :modal="showBackdrop"
    data-test="adyen-subscription-modal"
    class="adyen-subscription-modal"
    append-to-body
    @opened="opened"
    @closed="emitEvent"
  >
    <div class="adyen-subscription">
      <div v-if="!isSubscribed || isCanceled">
        <update-payment-info
          :update="isSubscribed && !isCanceled"
          :show_modal="show_modal"
          heading="Billing Information"
          @success="paymentSuccess"/>
      </div>
      <div v-else>
        <update-payment-info
          :update="isSubscribed && !isCanceled"
          :show_modal="show_modal"
          heading="Update payment method"
          @success="paymentMethodUpdateSuccess"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
import UpdatePaymentInfo from './UpdatePaymentInfo';

export default {
  name: 'AdyenSubscriptionModal',
  components: {
    'update-payment-info': UpdatePaymentInfo,
  },
  props: {
    show_modal: {
      default: false,
      type: Boolean,
    },
    update_payment: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      showModal: this.show_modal,
      showPaymentForm: false,
    };
  },
  computed: {
    isSubscribed() {
      return this.$store.getters.user && this.$store.getters.user.is_subscribed;
    },
    isCanceled() {
      return this.$store.getters.userSubscription && this.$store.getters.userSubscription.is_cancelled;
    },
    showBackdrop() {
      const width = window.innerWidth;
      return width > 567;
    },
  },
  watch: {
    show_modal(newVal) {
      this.showModal = newVal;
    },
  },
  methods: {
    emitEvent() {
      this.showPaymentForm = false;
      this.$emit('close');
    },
    showAdyenForm() {
      this.showPaymentForm = true;
    },
    paymentSuccess() {
      this.$emit('close', true);
      // this.$router.push({ path: '/listen', query: { newSubscription: true } });
    },
    paymentMethodUpdateSuccess() {
      this.$emit('close', true);
    },
    opened() {
      this.showAdyenForm();
      // if (this.update_payment) {
      //   this.showAdyenForm();
      // }
    },
  },
};
</script>
<style lang="scss">
.adyen-subscription-modal{
  z-index: 10000 !important;
  .el-dialog{
    border: 1px solid #BABABA;
    max-width: 712px;
    width: 100%;
    border-radius: 8px;

    .el-dialog__header{
      padding: 0px;
      .el-dialog__headerbtn .el-dialog__close{
        font-size: 24px;
        color: #666666;
      }
    }
    .el-dialog__body{
      padding: 57px 123px;
      .heading {
        font-size: 24px;
        line-height: 28px;
        margin-bottom: 34px;
        margin-top: 0;
        color: #111111;
      }
      .info-section{
        h4{
          margin-bottom: 32px;
        }
        p{
          margin-bottom: 30px;
        }
        .el-button{
          margin-top: 12px;
        }
      }
      p {
        font-size: 16px;
        color: #111111;
        line-height: 20px;
      }
      .action-button, .purchase-btn {
        font-size: 16px;
        line-height: 20px;
        font-weight: normal;
        margin-top: 42px;
      }
    }
  }
  .adyen-subscription{
    text-align: left;
  }
}

@media (max-width: 567px) {
  .adyen-subscription-modal{
    .el-dialog{
      border: 0px;
      border-radius: 0px;
      margin-top: 72px !important;
      margin-bottom: 0px !important;
      height: auto;
      min-height: 100vh;
      z-index: 11000;
      .el-dialog__header{
        padding: 0px;
        .el-dialog__headerbtn .el-dialog__close{
          font-size: 24px;
          color: #666666;
        }
      }
      .el-dialog__body{
        padding: 21px 32px;
        .heading {
          font-size: 24px;
          line-height: 28px;
          margin-bottom: 34px;
          margin-top: 0;
          color: #111111;
          text-align: left;
        }
        .info-section{
          h4{
            margin-bottom: 32px;
          }
          p{
            margin-bottom: 30px;
          }
          .el-button{
            margin-top: 12px;
          }
        }
        p {
          font-size: 16px;
          color: #111111;
          line-height: 20px;
        }
        .action-button, .purchase-btn {
          font-size: 16px;
          line-height: 20px;
          font-weight: normal;
          margin-top: 42px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/subscription/UpgradeModal.vue